import clsx from "clsx";
import TextArea, { TextAreaProps } from "./TextArea";
import Label from "./Label";
import LabelTextAreaStyle from "./css/LabelTextArea.module.css";
import { forwardRef, ReactNode } from "react";
import Text from "./Text";

type LabelTextAreaProps = TextAreaProps & {
    label?: ReactNode;
    textArea?: ReactNode;
    id?: string;
    required?: boolean;
    direction?: "top" | "left";
}

const LabelTextArea = forwardRef<HTMLTextAreaElement, LabelTextAreaProps>(
    ({ label, textArea, id, direction = "top", required = false, style, readOnly, fullWidth, ...props }: LabelTextAreaProps, ref) => {
        const _label = label ?? <Text size={direction === "top" ? "sm" : "md"}>라벨</Text>;
        return (
            <div className={clsx(
                    LabelTextAreaStyle['label-textarea-container'],
                    LabelTextAreaStyle[`label-textarea-container-${direction}`]
                )}
                style={{
                    width: fullWidth ? "100%" : undefined,
                }}
            >
                <Label required={required} htmlFor={id}>{_label}</Label>
                <TextArea
                    id={id}
                    style={{
                        backgroundColor: readOnly ? "#F5F7F9" : "#FFFFFF",
                        ...style
                    }}
                    readOnly={readOnly}
                    fullWidth={fullWidth}
                    ref={ref}
                    {...props}
                />
            </div>
        );
    }
);

export default LabelTextArea;

